/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Ref, onMounted, onUnmounted, watch, nextTick,
} from '@vue/composition-api';
import router from '@/router';
import { updateModuleState } from '@/store';

// 定义暴露类型
export type NavbarExpose = { root: HTMLElement | null };
export const useNavbarHeight = (navbarRef: Ref<NavbarExpose | null>): void => {
  let timer: number | null = null;

  const updateNavbarHeight = () => {
    /** 延迟100执行，避免获取到错误的高度
       * 原因：项目中存在使用原生导航栏的页面，两种导航栏类型页面跳转，会调用bridge方法隐藏/展示原生导航栏，由于bridge方法执行时间是异步的，所以需要延迟执行获取高度方法
       */
    timer = window.setTimeout(() => {
      if (!navbarRef.value) return;
      const height = (navbarRef.value?.root?.clientHeight as number) || 0;
      updateModuleState('base', {
        coffeeNavBarHeight: height,
      });

      // 设置 CSS 变量
      document.documentElement.style.setProperty('--coffee-nav-bar-height', `${height}px`);
    }, 100);
  };

  // 监听路由变化
  watch(
    () => router.currentRoute,
    () => {
      nextTick(updateNavbarHeight);
    },
    { immediate: true },
  );

  // 组件挂载后更新高度
  onMounted(() => {
    nextTick(updateNavbarHeight);
  });

  // 组件销毁时重置导航栏高度
  onUnmounted(() => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    updateModuleState('base', {
      coffeeNavBarHeight: 0,
    });
  });
};
